var exports = {
  "k": "DisableInvitesButton.module__container___M2I0aG",
  "i": "DisableInvitesButton.module__message___M2I0aG",
};

module.exports = exports;
